// Reserved region segment meaning "no filter" (the default landing).
export const ALL_REGIONS_CODE = "all";
export const DEFAULT_REGION = ALL_REGIONS_CODE;

// localStorage key remembering the last-opened region (for the return redirect).
export const REGION_STORAGE_KEY = "active-region-code";

// Prefix an app path (leading-slash, e.g. "/users/123") with the region segment.
export function regionPath(region: string, path: string): string {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `/${region}${clean}`;
}

// Strip the leading region segment from a pathname:
//   "/in/users/123" -> "/users/123",  "/in" -> "/"
export function regionlessPath(pathname: string): string {
  const rest = pathname.split("/").slice(2).join("/");
  return rest ? `/${rest}` : "/";
}

// Last-opened region persistence (for the return redirect).
export function getStoredRegion(): string | null {
  try {
    return localStorage.getItem(REGION_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredRegion(region: string): void {
  try {
    localStorage.setItem(REGION_STORAGE_KEY, region);
  } catch {
    // ignore storage errors (private mode / quota)
  }
}
